import fallback01 from '@/assets/cities/fallback-01.jpg'
import fallback02 from '@/assets/cities/fallback-02.jpg'
import fallback03 from '@/assets/cities/fallback-03.jpg'
import fallback04 from '@/assets/cities/fallback-04.jpg'
import fallback05 from '@/assets/cities/fallback-05.jpg'
import fallback06 from '@/assets/cities/fallback-06.jpg'
import fallback07 from '@/assets/cities/fallback-07.jpg'
import fallback08 from '@/assets/cities/fallback-08.jpg'
import fallback09 from '@/assets/cities/fallback-09.jpg'
import fallback10 from '@/assets/cities/fallback-10.jpg'
import type { City } from '@/types/home'

/**
 * Old Popular Cities landmark photos (fort, temple, arch, skyline).
 * Bundled by Vite so they are not swallowed by the Laravel `/images` proxy.
 */
export const CITY_FALLBACK_IMAGES = [
  fallback01,
  fallback02,
  fallback03,
  fallback04,
  fallback05,
  fallback06,
  fallback07,
  fallback08,
  fallback09,
  fallback10,
] as const

/** Match the original slider: Rajkot fort, Ahmedabad temple, Surat skyline, Jamnagar gateway. */
const CITY_FALLBACK_BY_SLUG: Record<string, string> = {
  rajkot: CITY_FALLBACK_IMAGES[0],
  ahmedabad: CITY_FALLBACK_IMAGES[1],
  jamnagar: CITY_FALLBACK_IMAGES[2],
  vadodara: CITY_FALLBACK_IMAGES[3],
  surat: CITY_FALLBACK_IMAGES[4],
  bhavnagar: CITY_FALLBACK_IMAGES[5],
  gandhinagar: CITY_FALLBACK_IMAGES[6],
  junagadh: CITY_FALLBACK_IMAGES[7],
  morbi: CITY_FALLBACK_IMAGES[8],
  gondal: CITY_FALLBACK_IMAGES[9],
  anand: CITY_FALLBACK_IMAGES[3],
}

export function cityFallbackImage(slug?: string | null, index = 0): string {
  const key = (slug ?? '').toLowerCase().trim()
  if (key && CITY_FALLBACK_BY_SLUG[key]) {
    return CITY_FALLBACK_BY_SLUG[key]
  }

  return CITY_FALLBACK_IMAGES[Math.abs(index) % CITY_FALLBACK_IMAGES.length]
}

/** Fill unique old photos only when a city has no uploaded image. Never replace a real photo. */
export function applyCityImageFallbacks(cities: City[]): City[] {
  return cities.map((city, index) => {
    if (city.image) {
      return city
    }

    return { ...city, image: cityFallbackImage(city.slug, index) }
  })
}
